var _module_exports = "<ul class=\"nav navbar-nav navbar-sideborder navbar-right\">\n  <li class=\"dropdown\">\n    <a href=\"https://localcommerce.atlassian.net/jira/software/c/projects/SD/boards/426#\" target=\"_blank\">\n      <span class=\"glyphicon glyphicon-earphone m-r-xs\"></span>\n      Request Support\n    </a>\n  </li>\n  <li class=\"dropdown logout cursor-pointer\"\n      data-ui-sref=\"auth.signout\"\n      uib-dropdown>\n    <p class=\"v-middle wrapper m-n\">\n      <span class=\"glyphicon glyphicon-log-out m-r-xs\"></span>\n      Logout\n    </p>\n  </li>\n</ul>\n";;
var path = '/app/common/partials/header/subnav.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/partials/header/subnav.html
// module id = 1166
// module chunks = 0